import { NgModule } from "@angular/core";
import { LoggedInGuard } from 'src/app/guards/logged-in.guard';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from '../pages.component';
import { PreviewDocsUserListComponent } from './docuserlist/preview-docs-user-list.component';
import { PreviewDocsUserComponent } from './previewuserdocs/preview-docs-user.component';

const routes: Routes = [
    { path: 'Preview', component: PagesComponent, canActivate: [LoggedInGuard], children: [
        { path: '', component: PreviewDocsUserListComponent, canActivate: [LoggedInGuard] },
        { path: ':id', component: PreviewDocsUserComponent, canActivate: [LoggedInGuard] }
      ]
    }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class DocPreviewRoutingModule { }

